var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCatalog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11467_220268",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11467_220268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 11H17C17.2833 11 17.5207 10.904 17.712 10.712C17.904 10.5207 18 10.2833 18 10C18 9.71667 17.904 9.479 17.712 9.287C17.5207 9.09567 17.2833 9 17 9H11C10.7167 9 10.4793 9.09567 10.288 9.287C10.096 9.479 10 9.71667 10 10C10 10.2833 10.096 10.5207 10.288 10.712C10.4793 10.904 10.7167 11 11 11ZM11 14H13C13.2833 14 13.521 13.904 13.713 13.712C13.9043 13.5207 14 13.2833 14 13C14 12.7167 13.9043 12.479 13.713 12.287C13.521 12.0957 13.2833 12 13 12H11C10.7167 12 10.4793 12.0957 10.288 12.287C10.096 12.479 10 12.7167 10 13C10 13.2833 10.096 13.5207 10.288 13.712C10.4793 13.904 10.7167 14 11 14ZM11 8H17C17.2833 8 17.5207 7.90433 17.712 7.713C17.904 7.521 18 7.28333 18 7C18 6.71667 17.904 6.479 17.712 6.287C17.5207 6.09567 17.2833 6 17 6H11C10.7167 6 10.4793 6.09567 10.288 6.287C10.096 6.479 10 6.71667 10 7C10 7.28333 10.096 7.521 10.288 7.713C10.4793 7.90433 10.7167 8 11 8ZM8 18C7.45 18 6.97933 17.8043 6.588 17.413C6.196 17.021 6 16.55 6 16V4C6 3.45 6.196 2.979 6.588 2.587C6.97933 2.19567 7.45 2 8 2H20C20.55 2 21.021 2.19567 21.413 2.587C21.8043 2.979 22 3.45 22 4V16C22 16.55 21.8043 17.021 21.413 17.413C21.021 17.8043 20.55 18 20 18H8ZM8 16H20V4H8V16ZM4 22C3.45 22 2.97933 21.8043 2.588 21.413C2.196 21.021 2 20.55 2 20V7C2 6.71667 2.096 6.479 2.288 6.287C2.47933 6.09567 2.71667 6 3 6C3.28333 6 3.521 6.09567 3.713 6.287C3.90433 6.479 4 6.71667 4 7V20H17C17.2833 20 17.5207 20.096 17.712 20.288C17.904 20.4793 18 20.7167 18 21C18 21.2833 17.904 21.5207 17.712 21.712C17.5207 21.904 17.2833 22 17 22H4Z",
    fill: "#AEB3C5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalog);
export default __webpack_public_path__ + "static/media/Catalog.125390bc2992cb471766dcecb2b329c5.svg";
export { ForwardRef as ReactComponent };